import * as React from 'react';
import { UitkCarousel } from 'uitk-react-carousel';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { useClickTracker } from '@shared-ui/clickstream-analytics-context';
export var ActivityCardImageCarousel = function (_a) {
  var _b, _c;
  var carousel = _a.carousel,
    imageAspectRatio = _a.imageAspectRatio;
  var items = carousel.items,
    nextButton = carousel.nextButton,
    previousButton = carousel.previousButton;
  var clickTracker = useClickTracker();
  var analytics = nextButton === null || nextButton === void 0 ? void 0 : nextButton.analytics;
  var renderImage = function (image, key) {
    return React.createElement(UitkImage, {
      alt: image === null || image === void 0 ? void 0 : image.description,
      src: image === null || image === void 0 ? void 0 : image.url,
      key: key,
      lazyLoading: "lazy"
    });
  };
  var renderMedia = function (media) {
    switch (media.__typename) {
      case 'Image':
        return React.createElement(UitkFigure, {
          ratio: imageAspectRatio !== null && imageAspectRatio !== void 0 ? imageAspectRatio : UitkFigureAspectRatioType.R16_9
        }, renderImage(media));
      default:
        return null;
    }
  };
  var renderImageCarouselItem = function (mediaItem) {
    switch (mediaItem.__typename) {
      case 'ActivityMediaItem':
        return renderMedia(mediaItem.media);
      default:
        return null;
    }
  };
  var carouselItems = items.map(function (item) {
    switch (item.__typename) {
      case 'EGDSMediaCarouselItem':
        return renderImageCarouselItem(item.media);
      default:
        return null;
    }
  });
  var onIndexChange = function () {
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
  };
  return React.createElement("div", {
    "data-testid": "activity-image-carousel"
  }, React.createElement(UitkCarousel, {
    buttonText: {
      nextButton: (_b = nextButton === null || nextButton === void 0 ? void 0 : nextButton.accessibility) !== null && _b !== void 0 ? _b : '',
      prevButton: (_c = previousButton === null || previousButton === void 0 ? void 0 : previousButton.accessibility) !== null && _c !== void 0 ? _c : ''
    },
    carouselName: "activity-image-carousel",
    loop: true,
    navigationIconId: {
      next: 'next-button',
      prev: 'prev-button'
    },
    onIndexChange: onIndexChange,
    itemsVisible: {
      lg: 1,
      md: 1,
      sm: 1
    },
    pageBy: 1,
    peek: false,
    startIndex: 0,
    pagingInset: true,
    pagingOverlay: true
  }, carouselItems));
};